/* London After Five / Horizon 4.2.0: delegated handlers survive cart section morphs */
import { CartLinesUpdateEvent } from '@shopify/events';

function updateArrowState(carousel) {
  const track = carousel.querySelector('[data-laf-track]');
  if (!track) return;
  const prev = carousel.querySelector('[data-laf-prev]');
  const next = carousel.querySelector('[data-laf-next]');
  const max = Math.max(0, track.scrollWidth - track.clientWidth);
  if (prev) prev.disabled = track.scrollLeft <= 2;
  if (next) next.disabled = track.scrollLeft >= max - 2;
}

function scrollCarousel(button) {
  const carousel = button.closest('.laf-upsell__carousel');
  const track = carousel?.querySelector('[data-laf-track]');
  if (!track) return;
  const first = track.querySelector('.laf-upsell__card');
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  const distance = (first?.getBoundingClientRect().width || track.clientWidth) + gap;
  track.scrollBy({ left: distance * (button.hasAttribute('data-laf-next') ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
}

async function addUpsell(button) {
  if (button.disabled) return;
  const id = Number(button.dataset.lafAdd);
  if (!Number.isSafeInteger(id) || id <= 0) return;
  const root = button.closest('[data-laf-upsell]');
  const status = root?.querySelector('[data-laf-status]');
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';
  if (status) status.textContent = '';
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'cart', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise
  }));
  try {
    const sectionIds = [...new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(el => el.dataset.sectionId).filter(Boolean).concat('cart-drawer-section'))];
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(','), sections_url: location.pathname })
    });
    const payload = await response.json();
    if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'Unable to add item');
    const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Could not update cart display');
    const cart = await cartResponse.json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { sections: payload.sections, items: cart.items, itemCount: cart.item_count, didError: false, source: 'laf-cart-upsell' }
    });
    if (status?.isConnected) status.textContent = 'Added to your cart';
    if (button.isConnected) button.textContent = 'ADDED';
  } catch (error) {
    deferred.resolve({detail:{ didError:true }});
    if (status?.isConnected) status.textContent = error.message || 'Please try again';
    if (button.isConnected) button.textContent = 'RETRY';
  } finally {
    if (button.isConnected) {
      button.disabled = false;
      setTimeout(() => { if (button.isConnected) button.textContent = originalText; }, 1500);
    }
  }
}

if (!window.__lafCartExtrasInitialized) {
  window.__lafCartExtrasInitialized = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || !button.closest('#cart-drawer [data-laf-advanced-cart]')) return;
    if (button.matches('[data-laf-next], [data-laf-prev]')) scrollCarousel(button);
    if (button.matches('[data-laf-add]')) addUpsell(button);
  });
  document.addEventListener('scroll', event => {
    if (event.target.matches?.('#cart-drawer [data-laf-track]')) {
      updateArrowState(event.target.closest('.laf-upsell__carousel'));
    }
  }, true);
  const sync = () => document.querySelectorAll('#cart-drawer [data-laf-upsell] .laf-upsell__carousel').forEach(updateArrowState);
  document.addEventListener('theme-drawer:open', sync);
  window.addEventListener('resize', sync, { passive:true });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('DOMContentLoaded', sync);
  sync();
}
